import { BoxChip } from "../BoxChip";
import * as StateLib from "@/Utils/StateLib";

export type Action = {
  type: string;
  payload: any;
  isPosition?: boolean;
  clearEmailInvite?: boolean;
};

export type Topbox = Nullable<{
  topBoxID: string;
  topBoxName: string;
  topBoxTitle: string;
  label: string;
}>;

export function topboxHandler<FormState>(action: Action, dirtyState: FormState): FormState {
  if (action.payload === null) {
    return { ...dirtyState, topbox: null };
  } else {
    const fetchedData = action.payload;
    const newTopbox = {
      topBoxID: fetchedData.getValue(),
      topBoxName: fetchedData.name,
      topBoxTitle: fetchedData.title,
      label: fetchedData.label()
    };
    return { ...dirtyState, topbox: newTopbox };
  }
}

export type BuilderModalProps<FormState> = {
  show: boolean;
  onClose: () => void;
  onCreate: (formState: FormState) => void;
};

/**
 * Populate the modal's topbox picker. When `overrideRef` is supplied (e.g.
 * from `?topOfChart=`), resolve that record directly so deep-link URLs drive
 * the pre-selected top box. Otherwise fall back to whichever record the
 * subchart manager currently has as the top of the active page.
 */
export const getTopOfChartFunc = (dispatch: any) => (overrideRef?: string | null) => {
  const scm = StateLib.GetSubChartMgr();
  if (!scm) return null;

  let topDBObj = null;
  if (overrideRef != null && overrideRef !== "") {
    topDBObj = scm.LookupObjByRef?.(overrideRef) ?? null;
  }
  if (topDBObj == null) {
    if (!scm.GetCurrentSubChart()) return null;
    topDBObj = scm.GetCurrentTopObj();
  }
  if (topDBObj == null) return null;

  const lookupRecordObj = BoxChip.FromObjDBObject(topDBObj);
  dispatch({
    type: "SET_TOPBOX",
    payload: lookupRecordObj
  });
};
